import { Pipe, PipeTransform } from '@angular/core';
import { Table } from 'primeng/table';
import { MxBrowserStorageService, MxStorageType } from 'src/app/core/services';

@Pipe({ standalone: false,
  name: 'mxTableHasFilters',
  pure: false,
})
export class MxTableHasFiltersPipe implements PipeTransform {
  constructor() {}
  transform(tableLocalStorageKey: string): any {
    let ret = false;
    
    const tableLocalStorageOptions = MxBrowserStorageService.get(
      MxStorageType.Local,
      tableLocalStorageKey
    );

    if (tableLocalStorageOptions?.filters) {
      Object.keys(tableLocalStorageOptions.filters).forEach((key) => {
        const filter = { ...(tableLocalStorageOptions.filters as any)[key][0] };
        if (filter?.value !== null) {
          ret = true;
        }
      });
    }
    return ret;
  }
}
